/*
 * @Author: Teemo Ding
 * @Date: 2022-02-17 14:38:39
 * @LastEditTime: 2022-06-30 16:48:49
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/CommunicationTemplateDetail/TemplateContent/index.tsx
 */
import {
  Button,
  Input,
  Label,
  RadioGroup,
  RadioItem,
} from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import Link from '@/src/components/Link/Link';
import { CommunicationGatewayProvider } from '@/src/types/common/communication';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { Form } from 'antd';
import { get } from 'lodash';
import React, { Fragment, memo } from 'react';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { getAllLanguage } from 'src/request/common';
import { getParameter } from 'src/tools/helper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import {
  SendgridTemplateContentInput,
  TemplateContentInput,
  TemplateLanguage,
} from '../../Components/FormComponents';
import { conditions, templateCategoryList } from '../config';
import css from '../css.module.less';
import { IParams } from '../index';

const TemplateContent = ({
  conditionsAll,
  variables,
  // disabledForAll,
  form,
  disableEdit,
  disableDelete,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const destination = getParameter('destination');
  const { data: languages = [] } = useRequest(() => getAllLanguage());
  const { gateway, channelType } = useParams() as IParams;
  const manualLanguagesOption = (languages || []).map((language) => ({
    label: language.description,
    value: language.languageTag,
  }));

  const validatorContent = (variableIndex, formItemName) => {
    const allTemplateCategory = templateCategoryList.flatMap(
      (item) => item.children,
    );
    const categoryIndex = allTemplateCategory.filter(
      (o) => o.value === get(variableIndex, [0, 'category']),
    );

    return [
      {
        validator: async (x, value) => {
          if (!value) {
            return Promise.reject(
              new Error(
                replaceI18nVariables(
                  getI18n('general.fieldisrequired'),
                  formItemName,
                ),
              ),
            );
          }
          const hasError = (variableIndex || []).reduce((pre, now) => {
            if (value.indexOf(`{{${get(now, 'variable.name')}}}`) == -1) {
              return true;
            } else {
              return pre;
            }
          }, false);
          if (hasError) {
            return Promise.reject(
              new Error(
                replaceI18nVariables(
                  getI18n(
                    'storeCommunicationSetting.common.validateErrorText1',
                  ),
                  variableIndex
                    .map((item) => `{{${get(item, 'variable.name', '')}}} `)
                    .join(`${getI18n('general.and')} `),
                  get(categoryIndex, [0, 'label']),
                ),
              ),
            );
          }
        },
      },
    ];
  };

  const calculateLanguagesOption = (index) => {
    const selectedLanguages = form
      .getFieldValue('templateContent')
      .filter((_, oIndex) => oIndex !== index)
      .flatMap((item) => (item || {}).languages);
    const languagesOption = manualLanguagesOption.filter(
      (o) => !selectedLanguages.includes(o.value),
    );
    return languagesOption;
  };
  const viewInstruction = (
    <div className={css.container}>
      <div className={css.icon}>
        <InfoCircleOutlined />
      </div>
      <div>
        {getI18n('storeCommunicationSetting.common.viewInstructionTitle')}
        <a
          target='_blank'
          href='http://doc.yuntongxun.com/pe/5a533d8f3b8496dd00dce068'
          className={css.tagsRightPart}>
          {getI18n('storeCommunicationSetting.common.templateContentInputLink')}
        </a>
      </div>
    </div>
  );

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('storeCommunicationSetting.common.templateContent')}>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) => {
          return (
            prevValues.category !== curValues.category ||
            prevValues.forAll !== curValues.forAll
          );
        }}>
        {({ getFieldValue }: any) => {
          const category = getFieldValue('category');
          const forAll = getFieldValue('forAll');

          const conditionIndex = (conditionsAll || []).filter(
            (o) => o.category === category,
          );
          const variableIndex = variables.filter(
            (o) => o.category === category && get(o, 'variable.required'),
          );
          return (
            <Fragment>
              {conditionIndex.length ? (
                <h3>
                  {getI18n('storeCommunicationSetting.common.templateSetting')}
                </h3>
              ) : null}
              {conditionIndex.length ? (
                <Form.Item
                  name='forAll'
                  className={css.forAll}
                  initialValue={true}
                  labelCol={{ span: 24 }}>
                  <RadioGroup disabled={disableEdit}>
                    <div className={css.radioItem}>
                      <RadioItem value={true}>
                        {getI18n(
                          'storeCommunicationSetting.common.forAllRadio1',
                        )}
                      </RadioItem>
                    </div>
                    <div className={css.radioItem}>
                      <RadioItem value={false}>
                        {getI18n(
                          'storeCommunicationSetting.common.forAllRadio2',
                        )}
                      </RadioItem>
                    </div>
                  </RadioGroup>
                </Form.Item>
              ) : null}
              <Form.List name='templateContent'>
                {(fields, { add, move, remove }) => (
                  <Fragment>
                    {fields.map((_, index) => (
                      <div className={css.templateContent} key={index}>
                        <div className={css.templateContentItem}>
                          <TemplateLanguage
                            nameKey={[fields[index].name, ['languages']]}
                            manualOption={calculateLanguagesOption(
                              fields[index].name,
                            )}
                            disableEdit={disableEdit}
                          />
                          {gateway === CommunicationGatewayProvider.Cloopen &&
                            destination &&
                            forAll !== false && (
                              <Form.Item
                                label={
                                  <Label
                                    title={`${getI18n(
                                      'storeCommunicationSetting.common.templateID',
                                    )}*`}
                                  />
                                }
                                labelCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: replaceI18nVariables(
                                      getI18n('general.fieldisrequired'),
                                      getI18n(
                                        'storeCommunicationSetting.common.templateID',
                                      ),
                                    ),
                                  },
                                ]}
                                name={[fields[index].name, 'templateId']}>
                                <Input size='large' disabled={disableEdit} />
                              </Form.Item>
                            )}
                          {gateway !== CommunicationGatewayProvider.Sendgrid &&
                            forAll === false &&
                            conditionIndex.map((item, cIndex) => (
                              <div key={cIndex}>
                                {gateway ===
                                  CommunicationGatewayProvider.Cloopen &&
                                  destination && (
                                    <Form.Item
                                      label={
                                        <Label
                                          title={`${getI18n(
                                            'storeCommunicationSetting.common.templateIDTip',
                                          )} ${conditions[item.condition]}*`}
                                        />
                                      }
                                      labelCol={{ span: 24 }}
                                      rules={[
                                        {
                                          required: true,
                                          message: replaceI18nVariables(
                                            getI18n('general.fieldisrequired'),
                                            getI18n(
                                              'storeCommunicationSetting.common.templateID',
                                            ),
                                          ),
                                        },
                                      ]}
                                      name={[
                                        fields[index].name,
                                        'templateIdEach',
                                        item.condition,
                                      ]}>
                                      <Input
                                        size='large'
                                        disabled={disableEdit}
                                      />
                                    </Form.Item>
                                  )}
                                <TemplateContentInput
                                  disableEdit={disableEdit}
                                  key={cIndex}
                                  labelName={`${getI18n(
                                    'storeCommunicationSetting.common.templateContentTip',
                                  )} ${conditions[item.condition]}*`}
                                  nameKey={[
                                    fields[index].name,
                                    ['contents'],
                                    [item.condition],
                                  ]}
                                  listName={[
                                    'templateContent',
                                    fields[index].name,
                                    ['contents'],
                                    [item.condition],
                                  ]}
                                  rules={validatorContent(
                                    variableIndex,
                                    getI18n(
                                      'storeCommunicationSetting.common.templateContent',
                                    ),
                                  )}
                                  placeholder={`${getI18n(
                                    'storeCommunicationSetting.common.vercationCodeIs',
                                  )} ${variableIndex.map(
                                    (item) =>
                                      `{{${get(item, 'variable.name', '')}}} `,
                                  )}`}
                                  channelType={channelType}
                                />
                                {gateway ===
                                  CommunicationGatewayProvider.Cloopen &&
                                  destination &&
                                  viewInstruction}
                              </div>
                            ))}

                          {gateway !== CommunicationGatewayProvider.Sendgrid &&
                            forAll !== false && (
                              <TemplateContentInput
                                labelName={`${getI18n(
                                  'storeCommunicationSetting.common.templateContent',
                                )}*`}
                                nameKey={[fields[index].name, 'content']}
                                listName={[
                                  'templateContent',
                                  fields[index].name,
                                  'content',
                                ]}
                                rules={validatorContent(
                                  variableIndex,
                                  getI18n(
                                    'storeCommunicationSetting.common.templateContent',
                                  ),
                                )}
                                placeholder={`${getI18n(
                                  'storeCommunicationSetting.common.vercationCodeIs',
                                )} ${variableIndex.map(
                                  (item) =>
                                    `{{${get(item, 'variable.name', '')}}} `,
                                )}`}
                                channelType={channelType}
                                disableEdit={disableEdit}
                              />
                            )}
                          {gateway === CommunicationGatewayProvider.Cloopen &&
                            forAll !== false &&
                            destination &&
                            viewInstruction}

                          {gateway ===
                            CommunicationGatewayProvider.Sendgrid && (
                            <Form.Item
                              label={
                                <Label
                                  title={`${getI18n(
                                    'storeCommunicationSetting.common.subjectLine',
                                  )}*`}
                                  textLength={100}
                                  nameKey={[
                                    'templateContent',
                                    fields[index].name,
                                    'subject',
                                  ]}
                                />
                              }
                              rules={[
                                {
                                  required: true,
                                  message: replaceI18nVariables(
                                    getI18n('general.fieldisrequired'),
                                    getI18n(
                                      'storeCommunicationSetting.common.subjectLine',
                                    ),
                                  ),
                                },
                              ]}
                              labelCol={{ span: 24 }}
                              name={[fields[index].name, 'subject']}>
                              <Input size='large' disabled={disableEdit} />
                            </Form.Item>
                          )}
                          {gateway ===
                            CommunicationGatewayProvider.Sendgrid && (
                            <Form.Item
                              label={
                                <Label
                                  title={`${getI18n(
                                    'storeCommunicationSetting.common.senderName',
                                  )}*`}
                                  textLength={100}
                                  nameKey={[
                                    'templateContent',
                                    fields[index].name,
                                    'senderName',
                                  ]}
                                />
                              }
                              rules={[
                                {
                                  required: true,
                                  message: replaceI18nVariables(
                                    getI18n('general.fieldisrequired'),
                                    getI18n(
                                      'storeCommunicationSetting.common.senderName',
                                    ),
                                  ),
                                },
                              ]}
                              labelCol={{ span: 24 }}
                              name={[fields[index].name, 'senderName']}>
                              <Input size='large' disabled={disableEdit} />
                            </Form.Item>
                          )}
                          {gateway === CommunicationGatewayProvider.Sendgrid &&
                            forAll === false &&
                            conditionIndex.map((item, cIndex) => (
                              <SendgridTemplateContentInput
                                form={form}
                                key={cIndex}
                                labelName={`${getI18n(
                                  'storeCommunicationSetting.common.emailBodyTip',
                                )} ${conditions[item.condition]}*`}
                                rules={validatorContent(
                                  variableIndex,
                                  getI18n(
                                    'storeCommunicationSetting.common.emailBody',
                                  ),
                                )}
                                validateName={[
                                  'templateContent',
                                  fields[index].name,
                                  'contents',
                                  item.condition,
                                ]}
                                collapsible={true}
                                nameKey={[
                                  fields[index].name,
                                  'contents',
                                  item.condition,
                                ]}
                                disableEdit={disableEdit}
                              />
                            ))}
                          {gateway === CommunicationGatewayProvider.Sendgrid &&
                            forAll !== false && (
                              <SendgridTemplateContentInput
                                form={form}
                                labelName={`${getI18n(
                                  'storeCommunicationSetting.common.emailBodyHTML',
                                )}*`}
                                rules={validatorContent(
                                  variableIndex,
                                  getI18n(
                                    'storeCommunicationSetting.common.emailBody',
                                  ),
                                )}
                                collapsible={false}
                                validateName={[
                                  'templateContent',
                                  fields[index].name,
                                  'content',
                                ]}
                                nameKey={[fields[index].name, 'content']}
                                disableEdit={disableEdit}
                              />
                            )}
                        </div>
                        <div className={css.templateContentItem}>
                          <div className={css.top}>
                            {fields.length > 1 && (
                              <Button
                                type='danger'
                                ghost
                                onClick={() => remove(index)}
                                disabled={disableDelete}>
                                {getI18n('general.delete')}
                              </Button>
                            )}
                          </div>
                          <div>
                            {gateway ===
                              CommunicationGatewayProvider.Sendgrid && (
                              <Form.Item
                                label={
                                  <Label
                                    title={`${getI18n(
                                      'storeCommunicationSetting.common.senderEmail',
                                    )}*`}
                                  />
                                }
                                labelCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: replaceI18nVariables(
                                      getI18n('general.fieldisrequired'),
                                      getI18n(
                                        'storeCommunicationSetting.common.senderEmail',
                                      ),
                                    ),
                                  },
                                ]}
                                name={[fields[index].name, 'sender']}>
                                <Input size='large' disabled={disableEdit} />
                              </Form.Item>
                            )}
                            {gateway ===
                              CommunicationGatewayProvider.Sendgrid && (
                              <Form.Item
                                label={
                                  <Label
                                    title={getI18n(
                                      'storeCommunicationSetting.common.replyToOptional',
                                    )}
                                  />
                                }
                                labelCol={{ span: 24 }}
                                name={[fields[index].name, 'replyTo']}>
                                <Input size='large' disabled={disableEdit} />
                              </Form.Item>
                            )}
                            <h3 className={css.variablesTitle}>
                              {getI18n(
                                'storeCommunicationSetting.common.variables',
                              )}
                            </h3>
                            <p>
                              {getI18n(
                                'storeCommunicationSetting.common.variableTip',
                              )}{' '}
                              <Link to={'/'} className={css.learnMore}>
                                {getI18n(
                                  'storeCommunicationSetting.common.learnMore',
                                )}
                              </Link>
                            </p>
                            {(variableIndex || []).length > 0 && (
                              <React.Fragment>
                                <h3 className={css.variablesTitle}>
                                  {getI18n(
                                    'storeCommunicationSetting.common.requiredVariable',
                                  )}
                                </h3>
                                <p>
                                  {variableIndex.map(
                                    (item) =>
                                      `{{${get(item, 'variable.name', '')}}}`,
                                  )}
                                </p>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}

                    <Button
                      type='primary'
                      onClick={() => add()}
                      disabled={disableEdit}>
                      {getI18n(
                        'storeCommunicationSetting.common.addTemplateLanguage',
                      )}
                    </Button>
                  </Fragment>
                )}
              </Form.List>
            </Fragment>
          );
        }}
      </Form.Item>
    </SectionWrapper>
  );
};

export default memo(TemplateContent);
